import { SagaReturnType, call, put, takeLatest } from 'redux-saga/effects';
import { addTaskConstant } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  GET_TASK_AVAILABILITY_REQUEST,
  GET_TASK_AVAILABILITY_SUCCESS,
  GET_TASK_AVAILABILITY_FAILURE,
  GET_TASK_AVAILABILITY_LOADING,
} = addTaskConstant;

function* getTaskAvailability(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_TASK_AVAILABILITY_LOADING });
    const response = yield call(therapistSchedulingServices.getTaskAvailability, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_TASK_AVAILABILITY_SUCCESS, payload: response.data?.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_TASK_AVAILABILITY_FAILURE, payload: error });
  }
}

function* taskAvailabilitySaga() {
  yield takeLatest(GET_TASK_AVAILABILITY_REQUEST, getTaskAvailability);
}

export default taskAvailabilitySaga;
